module.exports = __webpack_public_path__ + "static/media/38.4e40e566.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/38.svg
// module id = 148
// module chunks = 0